import { ArgusStats, ArgusApp, ArgusCluster, ArgusStackDependency } from '@eng-portal/plugin-argus-common';
import { ArgusAPI, ArgusEnv, ArgusEvent, ArgusStack, ArgusStackInfo, EventQuery } from '../../../argus-common/src/argusApi';
import { v4 as uuidv4 } from 'uuid';

export class MockArgusClient implements ArgusAPI {
  async getStats(): Promise<ArgusStats> {
    return {
      num_apps: 5,
      num_clusters: 3,
      num_stacks: 2,
    };
  }

  async listApps(): Promise<ArgusApp[]> {
    return [
      {
        id: '1',
        create_time: '2023-01-01T00:00:00Z',
        update_time: '2023-01-02T00:00:00Z',
        name: 'Mock App 1',
        repo_slug: 'mock-app-1',
        project_root_path: 'mock-app-1',
        envs: [],
        permissions: [],
        admin_team: {
            id: 'admin-team',
            create_time: '2023-01-01T00:00:00Z',
            update_time: '2023-01-02T00:00:00Z',
            name: 'Admin Team',
            permission: [],
            admin_of_apps: [],
            reader_of_apps: [],
            admin_of_envs: [],
            reader_of_envs: [],
            permission_team: [],
        },
        reader_team: {
            id: 'reader-team',
            create_time: '2023-01-01T00:00:00Z',
            update_time: '2023-01-02T00:00:00Z',
            name: 'Reader Team',
            permission: [],
            admin_of_apps: [],
            reader_of_apps: [],
            admin_of_envs: [],
            reader_of_envs: [],
            permission_team: [],
        },
      },
    ];
  }

  async listStacks(_appName: string, _envName: string): Promise<ArgusStack[]> {
    return [
      {
        id: '1',
        create_time: '2023-01-01T00:00:00Z',
        update_time: '2023-01-02T00:00:00Z',
        name: 'supreme-crab',
        git_branch: 'cool-feature',
        base_url: 'https://github.com/mock-org/mock-repo.git',
        env: {
          name: 'rdev',
          id: '1',
          create_time: '2023-01-01T00:00:00Z',
          update_time: '2023-01-02T00:00:00Z',
          admin_team: {
            id: 'admin-team',
            create_time: '2023-01-01T00:00:00Z',
            update_time: '2023-01-02T00:00:00Z',
            name: 'Admin Team',
          },
          reader_team: {
              id: 'reader-team',
              create_time: '2023-01-01T00:00:00Z',
              update_time: '2023-01-02T00:00:00Z',
              name: 'Reader Team',
          },
          app: {
            id: '1',
            create_time: '2023-01-01T00:00:00Z',
            update_time: '2023-01-02T00:00:00Z',
            name: 'Mock App 1',
            repo_slug: 'mock-app-1',
            project_root_path: 'mock-app-1',
            admin_team: {
              id: 'admin-team',
              create_time: '2023-01-01T00:00:00Z',
              update_time: '2023-01-02T00:00:00Z',
              name: 'Admin Team',
            },
            reader_team: {
                id: 'reader-team',
                create_time: '2023-01-01T00:00:00Z',
                update_time: '2023-01-02T00:00:00Z',
                name: 'Reader Team',
            },
          },
          cluster: {
            id: '1',
            create_time: '2023-01-01T00:00:00Z',
            update_time: '2023-01-02T00:00:00Z',
            name: 'Mock Cluster 1',
            api_endpoint: 'https://mock-cluster-1.example.com',
            cluster_type: 'EKS',
            base_domain: 'mock-cluster.example.com',
            metrics_subdomain: 'mock-metrics.example.com',
            aws_account_id: '123456789012',
            aws_region: 'us-west-2',
            aws_assume_role_arn: 'arn:aws:iam::123456789012:role/MockRole',
            certificate_authority_data: 'mock-ca-data',
            secret_writer_provider: "AWS",
            labels: '{}',
            tiers: [],
          },
        },
      }
    ];
  }

  async getStackInfo(_appName: string, _envName: string, _stackName: string): Promise<ArgusStackInfo | undefined> {
    return {
      name: 'supreme-crab',
      git_branch: 'cool-feature',
      base_url: 'https://github.com/mock-org/mock-repo.git',
      metrics_url: 'https://metrics.example.com/metrics',
      updated_at: '2023-01-01T00:00:00Z',
      kubernetes: {
        namespace: 'mock-namespace',
        cluster_name: 'mock-cluster',
      },
      argo: {
        checked_at: '2026-01-01T00:00:00Z',
        revision: '76de935',
        message: 'Deployment completed successfully',
        synced_and_healthy: true,
        sync: {
          status: 'Synced',
          deployed_at: '2026-01-01T00:00:00Z',
          reconciled_at: '2026-01-01T00:00:00Z',
        },
        health: {
          message: 'Healthy',
          status: 'Healthy',
        },
        images: ['mock-image:1.0.0'],
        url: 'https://argocd.example.com/applications/mock-app/mock-stack',
      },
      grafana: {
        dashboard_url: 'https://grafana.example.com/dashboard/d/mock-dashboard'
      }
    };
  }

  async reportDependencies(_appName: string): Promise<ArgusStackDependency[]> {
    return [
      {
        app_name: 'Mock App 1',
        env_name: 'rdev',
        stack_name: 'supreme-crab',
        dep_type: 'helm',
        dep_name: 'stack',
        dep_version: '1.0.0',
      },
    ];
  }

  async deleteStack(_appName: string, _envName: string, _stackName: string): Promise<void> {
    return Promise.resolve();
  }

  async listEnvs(_appName: string): Promise<ArgusEnv[]> {
    return [
      {
        name: 'rdev',
        id: '1',
        create_time: '2023-01-01T00:00:00Z',
        update_time: '2023-01-02T00:00:00Z',
        admin_team: {
          id: 'admin-team',
          create_time: '2023-01-01T00:00:00Z',
          update_time: '2023-01-02T00:00:00Z',
          name: 'Admin Team',
        },
        reader_team: {
            id: 'reader-team',
            create_time: '2023-01-01T00:00:00Z',
            update_time: '2023-01-02T00:00:00Z',
            name: 'Reader Team',
        },
        app: {
          id: '1',
          create_time: '2023-01-01T00:00:00Z',
          update_time: '2023-01-02T00:00:00Z',
          name: 'Mock App 1',
          repo_slug: 'mock-app-1',
          project_root_path: 'mock-app-1',
          admin_team: {
            id: 'admin-team',
            create_time: '2023-01-01T00:00:00Z',
            update_time: '2023-01-02T00:00:00Z',
            name: 'Admin Team',
          },
          reader_team: {
              id: 'reader-team',
              create_time: '2023-01-01T00:00:00Z',
              update_time: '2023-01-02T00:00:00Z',
              name: 'Reader Team',
          },
        },
        cluster: {
          id: '1',
          create_time: '2023-01-01T00:00:00Z',
          update_time: '2023-01-02T00:00:00Z',
          name: 'Mock Cluster 1',
          api_endpoint: 'https://mock-cluster-1.example.com',
          cluster_type: 'EKS',
          base_domain: 'mock-cluster.example.com',
          metrics_subdomain: 'mock-metrics.example.com',
          aws_account_id: '123456789012',
          aws_region: 'us-west-2',
          aws_assume_role_arn: 'arn:aws:iam::123456789012:role/MockRole',
          certificate_authority_data: 'mock-ca-data',
          secret_writer_provider: "AWS",
          labels: '{}',
          tiers: [],
        },
      }
    ];
  }

  async listClusters(): Promise<ArgusCluster[]> {
    return [
        { id: '1',
          create_time: '2023-01-01T00:00:00Z',
          update_time: '2023-01-02T00:00:00Z',
          name: 'Mock Cluster 1',
          api_endpoint: 'https://mock-cluster-1.example.com',
          certificate_authority_data: 'mock-ca-data',
          cluster_type: 'EKS',
          base_domain: 'mock-cluster.example.com',
          metrics_subdomain: 'mock-metrics.example.com',
          aws_account_id: '123456789012',
          aws_region: 'us-west-2',
          aws_assume_role_arn: 'arn:aws:iam::123456789012:role/MockRole',
          secret_writer_provider: "AWS",
          permissions: [],
          envs: [],
          tiers: [],
          labels: '{}',
        }
    ];
  }

  async listEvents(_query: EventQuery): Promise<{ events: ArgusEvent[], hasMore: boolean, totalEventCount: number }> {
    const response: { events: ArgusEvent[], hasMore: boolean, totalEventCount: number } = {
      events: [
        eventify({
          id: uuidv4(),
          event_type: 'ENV_CREATED',
          source_system: 'argus-api',
          description: 'An environment was created',
          actor: '{"name":"user1"}',
          occurred_at: '2025-08-17T13:51:19Z',
          raw: '{"stack_name":"example-stack"}'
        }),
        eventify({
          id: uuidv4(),
          occurred_at: '2025-08-18T10:51:55Z',
          event_type: 'STACK_CREATED',
          source_system: 'argus-api',
          description: 'A stack was created',
          actor: '{"name":"user1"}',
          raw: '{"stack_name":"example-stack"}'
        }),
        eventify({
          id: uuidv4(),
          event_type: 'SECRET_SET',
          source_system: 'argus-api',
          description: 'A secret was created/updated',
          actor: '{"name":"user2"}',
          occurred_at: '2025-08-18T12:55:03Z',
          raw: '{"config_name":"example-config"}'
        }),
        eventify({
          id: uuidv4(),
          event_type: 'SECRET_DELETED',
          source_system: 'argus-api',
          description: 'A secret was deleted',
          actor: '{"name":"user3"}',
          occurred_at: '2025-08-18T14:11:47Z',
          raw: '{"config_name":"example-config"}'
        }),
        eventify({
          id: uuidv4(),
          event_type: 'STACK_DELETED',
          source_system: 'argus-api',
          description: 'A stack was deleted',
          actor: '{"name":"user2"}',
          occurred_at: '2025-08-18T15:21:31Z',
          raw: '{"stack_name":"example-stack"}'
        }),
      ],
      hasMore: false,
      totalEventCount: 1,
    };

    return response;
  }

  async listEventTypes(): Promise<string[]> {
    return [
      'ENV_CREATED',
      'STACK_CREATED',
      'SECRET_SET',
      'SECRET_DELETED',
      'STACK_DELETED',
      'CLUSTER_CREATED',
      'CLUSTER_DELETED',
      'STACK_SYNCED_AND_HEALTHY',
    ];
  }

  async listSourceSystems(): Promise<string[]> {
    return ['argus-api', 'argocd'];
  }
}

function eventify(event: Omit<ArgusEvent, 'source_id' | 'create_time'>): ArgusEvent {
  return {
    ...event,
    source_id: event.id,
    create_time: event.occurred_at,
  };
}
